module.exports = function() {
  return new Worker(__webpack_public_path__ + "5ec2d3a3c2387e8d0cae.worker.js");
};